import { BreadcrumbDataQuery } from '@lib/ui-components';
import {
  ReactQueryHateoasClientService,
} from '../libs/common-sdk/hateoas-rest-api-client/react-query-hateoas-client.service';

export const CompanyBranchBreadcrumbProvider: BreadcrumbDataQuery = {
  fetchFunction(id: string): () => Promise<any> {
    return function () {
      return ReactQueryHateoasClientService.findOneByAggregateId<any>('companyBranchViews', 'branchId', id);
    };
  },

  mapToBreadcrumb(data: any): string {
    return data.name;
  },

  query: 'companyBranchViews',
};
